export class MyRenderer {
    constructor(markerLibrary) {
      this.markerLibrary = markerLibrary;
    }

    //render marker for cluster
    render = (cluster, stats, map) => {
        let insidePinHTML = '<div>';
        insidePinHTML += cluster.count.toString();
        insidePinHTML += '</div>'
    
        const insidePin = document.createElement('div');
        insidePin.innerHTML = insidePinHTML;
        
        const pin = new this.markerLibrary.PinElement({
            borderColor: '#ff0099',
            background: '#ff0099',
            glyph: insidePin,
        })
    
        const marker =  new this.markerLibrary.AdvancedMarkerElement({
            position:cluster.position,
            map,
            content: pin.element,
            gmpClickable:true
    
        });
    
        return marker;
    } 
}
